<template>
  <div>
    <FilterOption @option="onOptionChange" />
    <Activitys
      :caption="$t('idp.title')"
      icon="cil-badge"
      @reload="onLoad"
      :item="item"
      @info="idpInfo"
    />
    <IDP ref="scrollToMe" v-if="isIdp" :options="option" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterOption from '@/projects/views/E-Performances/Estimate/components/FilterOption'
import Activitys from '@/projects/views/E-Performances/IndividualDevelopmentPlan/components/Activitys.vue'
import IDP from '@/projects/views/E-Performances/IndividualDevelopmentPlan/components/IDP.vue'

export default {
  name: 'IndividualDevelopmentPlan',
  components: { IDP, Activitys, FilterOption },

  props: {
    caption: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialog: true,
      option: {
        organization: '66cbe802a41ed9362a8579fa',
        agency: '00000000000000000000000',
        year: new Date().getFullYear() + 542
      },
      item: [
        {
          title: this.$t('idp.yourself'),
          type: 0,
          fields: [
            { key: 'index', label: this.$t('orders'), _style: 'width:50px; text-align: center' },
            { key: 'code', label: this.$t('staffID'), _style: 'width:100px;' },
            { key: 'position', label: this.$t('department') },
            { key: 'info', label: this.$t('fullname') },
            { key: 'status', label: this.$t('process') },
            { key: 'action', label: '#', _style: 'width:100px; text-align: center' }
          ],
          isTimeline: true,
          historys: []
        },
        {
          title: this.$t('idp.subordinate'),
          type: 1,
          fields: [
            { key: 'index', label: '#', _style: 'width:50px; text-align: center' },
            { key: 'code', label: this.$t('staffID'), _style: 'width:100px;' },
            { key: 'position', label: this.$t('department') },
            { key: 'info', label: this.$t('fullname') },
            { key: 'status', label: this.$t('process') },
            { key: 'action', label: '#', _style: 'width:100px; text-align: center' }
          ],
          isTimeline: false,
          historys: []
        }
      ],
      isIdp: false
    }
  },

  computed: {
    ...mapGetters({
      lang: 'setting/lang',
      objs: 'idp/objs',
      isReload: 'idp/isReload',
      objsIdp: 'idp/idp'
    })
  },

  watch: {
    lang(value) {
      this.item[0].title = this.$t('idp.yourself')
      this.item[0].fields = [
        { key: 'index', label: this.$t('orders'), _style: 'width:50px; text-align: center' },
        { key: 'code', label: this.$t('staffID'), _style: 'width:100px;' },
        { key: 'position', label: this.$t('department') },
        { key: 'info', label: this.$t('fullname') },
        { key: 'status', label: this.$t('process') },
        { key: 'action', label: '#', _style: 'width:100px; text-align: center' }
      ]

      this.item[1].title = this.$t('idp.subordinate')
      this.item[1].fields = [
        { key: 'index', label: this.$t('orders'), _style: 'width:50px; text-align: center' },
        { key: 'code', label: this.$t('staffID'), _style: 'width:100px;' },
        { key: 'position', label: this.$t('department') },
        { key: 'info', label: this.$t('fullname') },
        { key: 'status', label: this.$t('process') },
        { key: 'action', label: '#', _style: 'width:100px; text-align: center' }
      ]
    },

    isReload(value) {
      if (value === true) {
        this.onLoad({ keepCurrent: true })
        this.$store.commit('idp/isReload', false)
      }
    },

    objs(value) {
      const mappedData = value.item.map(item => ({
        id: item._id,
        code: item.accounts.accounts.code,
        position: item.position.agency.title.find(t => t.key === 'th').value,
        info: `${item.accounts.accounts.userinfo.prefix.find(t => t.key === 'th').value} ${item.accounts.accounts.userinfo.firstName.find(t => t.key === 'th').value} ${item.accounts.accounts.userinfo.lastName.find(t => t.key === 'th').value}`,
        status: item.status,
        value: item,
        assessor: `${item.assessor.accounts.accounts.userinfo.prefix.find(t => t.key === 'th').value} ${item.assessor.accounts.accounts.userinfo.firstName.find(t => t.key === 'th').value} ${item.assessor.accounts.accounts.userinfo.lastName.find(t => t.key === 'th').value}`,
        isTalent: item.isTalent,
        levels: item.levels
      }))

      if (value.isYourself === true) {
        this.item[0].historys = mappedData
      } else {
        this.item[1].historys = mappedData
      }
    },

    objsIdp(value) {
      this.isIdp = true
    }
  },

  mounted() {
    this.onInit()
  },

  methods: {
    onInit() {
      this.onLoad()
    },

    async onLoad(options = {}) {
      const { keepCurrent = false } = options || {}

      if (!keepCurrent) {
        this.isIdp = false
      }

      const body1 = {
        isYourself: true,
        organization: this.option.organization,
        year: parseInt(this.option.year)
      }

      const body2 = {
        isYourself: false,
        organization: this.option.organization,
        year: parseInt(this.option.year)
      }

      try {
        await Promise.all([
          this.$store.dispatch('idp/explore', body1),
          this.$store.dispatch('idp/explore', body2)
        ])
      } catch (err) {
        console.error('[idp] failed to reload list after save', err)
      }
    },

    onOptionChange(e) {
      this.option = {
        ...this.option,
        ...(e || {})
      }
      this.onLoad()
      this.scrollToRef()
    },

    idpInfo(value) {
      this.$store.commit('idp/idp', value.value)
      this.isIdp = true
      setTimeout(this.scrollToRef, 200)
    },

    scrollToRef() {
      this.$nextTick(() => {
        if (this.$refs.scrollToMe) {
          this.$refs.scrollToMe.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
